import {  Component,  Injector,  OnInit} from '@angular/core';
import { JackBaseComponentModule,MaterialModule,PageKind, UiModeType, } from 'jk-service';
import { jkSingleComponent,AdvComModule } from 'jk-advcom';
import { Mtrmb, } from '../_entity_mtr';
import { MtrmbService,  } from '../_service_mtr';
import { MtrmbEditComponent } from '../_edit_mtr';


@Component({
  selector: 'app-mtrki07',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
    //MtrmbEditComponent,
  ],
  templateUrl: './mtrki07Pkg.component.html',
  styleUrls: [],
})
export class Mtrki07Component extends jkSingleComponent implements OnInit {
  override _programId = 'mtrki07';
  override masterSrv: MtrmbService = new MtrmbService();
  override get srv(): MtrmbService {
    return this.masterSrv;
  }
  constructor() {
    super();
    this.uiMode=  UiModeType.dialog;
    this.title = '通訊錄建立';
    this.gridInitOpt = {programId:this.programId,sortField:'MB003',sort: 'asc',defaultSort: null,pageKind: this.pageKind};
    this.qbeConfig.addField = 'MB006,MB016,MB026,MB027';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = MtrmbEditComponent;


    // this.constructorInit();
  }

  override async constructorInit() {
    await super.constructorInit();
    this.masterSrv.cdr = this.cdr;
  };



}
